module.exports = __webpack_public_path__ + "img/5.5b56ee04.jpg";